import { getGoToBrandReferralsCTA } from "./shared";
export var BrandReferralCreditDiscrepancyIA = function BrandReferralCreditDiscrepancyIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return BRAND_REFERRALS_CREDIT_DISCREPANCY_TITLE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [BRAND_REFERRALS_CREDIT_DISCREPANCY_DESCRIPTION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getGoToBrandReferral;
        return (_getGoToBrandReferral = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral === void 0 ? void 0 : _getGoToBrandReferral.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getGoToBrandReferral2, _getGoToBrandReferral3;
        return (_getGoToBrandReferral2 = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral2 === void 0 ? void 0 : (_getGoToBrandReferral3 = _getGoToBrandReferral2.getLink) === null || _getGoToBrandReferral3 === void 0 ? void 0 : _getGoToBrandReferral3.call(_getGoToBrandReferral2);
      }
    }
  };
};
var BRAND_REFERRALS_CREDIT_DISCREPANCY_TITLE = function BRAND_REFERRALS_CREDIT_DISCREPANCY_TITLE(strictLocalize) {
  return strictLocalize({
    id: "aP3Gjj",
    defaultMessage: [{
      "type": 0,
      "value": "Porque existe uma discrepância no crédito"
    }]
  });
};
var BRAND_REFERRALS_CREDIT_DISCREPANCY_DESCRIPTION = function BRAND_REFERRALS_CREDIT_DISCREPANCY_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "lhaVmE",
    defaultMessage: [{
      "type": 0,
      "value": "O montante do crédito depende da promoção ativa quando envia o convite. Para se qualificar para o crédito, a marca deve utilizar o seu link de convite ou indicar que recebeu um convite da sua parte quando se registar na Faire. Para verificar o \"Crédito obtido\" com uma marca específica, aceda a \"Convidar marcas\" em \"Conta\" e selecione o separador \"Marcas que aderiram\". Se vir mensagens como \"Não utilizou o seu link\" ou \"Já ativa\", não é elegível para receber qualquer crédito de convite."
    }]
  });
};